function hideManufacturer(){
    for(let attributeName of document.querySelectorAll(".productAttributes .attributeName")){
      let tr = attributeName.closest("tr");
      let attributeNameText = attributeName.innerHTML;
      if(attributeNameText.trim() === "Hersteller"){
        tr.remove();
      }
    }
  }
  
  function hideStatus(){
    for(let attributeName of document.querySelectorAll(".productAttributes .attributeName")){
      let tr = attributeName.closest("tr");
      let attributeNameText = attributeName.innerHTML;
      if(attributeNameText.trim() === "Status"){
        tr.remove();
      }
    }
  }
  
  function hideVerkauf18(){
    for(let attributeName of document.querySelectorAll(".productAttributes .attributeName")){
      let tr = attributeName.closest("tr");
      let attributeNameText = attributeName.innerHTML;
      if(attributeNameText.trim() === "Verkauf ab 18"){
        tr.remove();
      }
    }
  }
  
  document.addEventListener("DOMContentLoaded", (event) => {
    hideManufacturer();
    hideStatus();
    hideVerkauf18();
  });